import api from '..'

const downloadCourses = (
  allSelected = false,
  courseIds: any[],
  q: any,
  source?: 'monitoring'
) => {
  return api.post('administration/courses/download', {
    courseIds: allSelected ? [] : courseIds,
    excludeCourseIds: allSelected ? courseIds : [],
    selectAll: allSelected,
    q,
    source,
  })
}

export default downloadCourses
